/* import __COLOCATED_TEMPLATE__ from './connect-api.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type PulseAccordion } from 'glint/pulse';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { action } from '@ember/object';

interface Signature {
  Args: {
    accordion: PulseAccordion;
    onContinue: () => void;
  };
}

export default class ConnectApiComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get freshdeskConfig() {
    return this.finStandaloneService.freshdeskConfig!;
  }

  get isComplete() {
    return this.freshdeskConfig?.isConnected;
  }

  @action
  continue() {
    if (this.args.onContinue) {
      this.args.onContinue();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Freshdesk::Deploy::Tickets::Integrate::ConnectApi': typeof ConnectApiComponent;
  }
}
